<template>
    <div class="page">
      <SiteHero
        pageTitle="Irvine"
        pageDescription="ICOI Village"
      />
    
      <div class="page-content">
        <div class="max-w-6xl mx-auto px-4 py-12">
          <div class="grid grid-cols-1 gap-8">
            <div id="schedule" class="location-block scroll-mt-32">
              <div class="grid grid-cols-1 gap-8">
                <div class="flex justify-between items-center">
                  <LocationTitle title="IRVINE SCHEDULE" />
                  <ButtonLink 
                    text="Register"
                    url="/irvine/register"
                    color="yellow"
                  />
                </div>
                <hr />
              </div>

              <div class="mt-4" id="irvineGymHours">
                
                <h3 class="text-3xl font-bold tracking-tight mb-6">
                  IRVINE - MAT HOURS
                </h3>
                <div class="overflow-x-auto w-full">
                  <table class="schedule-table w-full min-w-[700px] text-center">
                    <thead>
                      <tr>
                        <th
                          v-for="day in daysOfWeek"
                          :key="day"
                          class="px-4 py-2"
                        >
                          {{ capitalize(day) }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-for="day in daysOfWeek"
                          :key="day"
                          class="px-4 py-4 font-bold text-green-700 bg-green-100 whitespace-pre-line"
                        >
                          <ul>
                            <li v-for="(time, idx) in matHoursByDay(day)" :key="idx">{{ time }}</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- <SchedulePDFEmbed
                location="irvine"
                scheduleAsOf="Updated Schedule PDF (July 15, 2025)"
                pdfViewLink="/empire-schedule-7-15-2025.pdf"
                pdfDownloadLink="/empire-schedule-7-15-2025.pdf"
                iFrameSrc="/empire-schedule-7-15-2025.pdf"
                :statusMessage="pdfStatusMessage"
              /> -->

              <ScheduleCategory
                title="IRVINE - MENS CLASSES"
                id="irvineMensSchedule"
                scheduleType="mens"
                location="irvine"
              />
              <ScheduleCategory 
                title="IRVINE - WOMENS CLASSES"
                id="irvineWomensSchedule"
                scheduleType="womens"
                location="irvine"
              />
              <ScheduleCategory 
                title="IRVINE - KIDS CLASSES"
                id="irvineKidsSchedule"
                scheduleType="kids"
                location="irvine"
              />
            </div>
          </div>
        </div>

        <div class="max-w-6xl mx-auto px-4 py-12">
          <div class="grid grid-cols-1 gap-8">
            <div v-for="location in filteredLocations" :key="location.name">
              <TrainingGround :location="location" />
            </div>
          </div>
        </div>
      </div>
  
      <SiteFooter />
    </div>
  </template>
      
  <script>
  import LocationTitle from '../components/Schedule/LocationTitle.vue'
  import ScheduleCategory from '../components/Schedule/ScheduleCategory.vue'
  import SiteFooter from '../components/Footer/SiteFooter.vue'
  import SiteHero from '../components/Hero/SiteHero.vue'
  import TrainingGround from '../components/Location/TrainingGround.vue'
  import ButtonLink from '../components/Common/ButtonLink.vue'
  // import SchedulePDFEmbed from '../components/Location/SchedulePDFEmbed.vue'
  import locationsData from '../data/locations.json'
  import scheduleData from '../data/schedules.json'
  import '../assets/styles/page.css'
    
  export default {
    name: 'LocationsIrvine',
    components: {
      LocationTitle,
      ScheduleCategory,
      SiteFooter,
      SiteHero,
      TrainingGround,
      ButtonLink,
      // SchedulePDFEmbed
    },
    data() {
      return {}
    },
    computed: {
      filteredLocations() {
        return locationsData.locations.filter(location => location.locationUrl === 'irvine')
      },
      daysOfWeek() {
        return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      },
      // irvineLocation() {
      //   return locationsData.locations.find(location => location.locationUrl === 'irvine')
      // },
      // latestScheduleEditDate() {
      //   const irvineSchedules = scheduleData.schedule?.irvine || {}
      //   let latestDate = null
      //   Object.keys(irvineSchedules).forEach(category => {
      //     const categoryData = irvineSchedules[category]
      //     if (categoryData?.recentEditDate) {
      //       const editDate = new Date(categoryData.recentEditDate)
      //       if (!latestDate || editDate > latestDate) {
      //         latestDate = editDate
      //       }
      //     }
      //   })
      //   return latestDate
      // },
      // pdfStatusMessage() {
      //   const location = this.irvineLocation
      //   if (!location || !location.pdfDate) {
      //     return "View or download the most current schedule"
      //   }
      //   if (location.pdfWarningOverride) {
      //     return "PDF may not reflect recent changes. Please verify below or contact the studio."
      //   }
      //   const pdfDate = new Date(location.pdfDate)
      //   const latestScheduleDate = this.latestScheduleEditDate
      //   if (!latestScheduleDate) {
      //     return "View or download the most current schedule"
      //   }
      //   if (pdfDate < latestScheduleDate) {
      //     return "PDF may not reflect recent changes. Please verify below or contact the studio."
      //   }
      //   return "View or download the most current schedule"
      // }
    },
    methods: {
      matHoursByDay(day) {
        const days = scheduleData.schedule?.irvine?.matHours?.days || {};
        const dayData = days[day] || [];
        return dayData.map(item => {
          if (item.timeStart && item.timeEnd) {
            const startTime = this.formatTimeWithAMPM(item.timeStart);
            const endTime = this.formatTimeWithAMPM(item.timeEnd);
            return `${startTime} - ${endTime}`;
          }
          return '';
        }).filter(time => time !== '');
      },
      formatTimeWithAMPM(time) {
        if (!time) return '';
        const [hours, minutes] = time.split(':');
        const hourNumber = parseInt(hours, 10);
        const timeDisplay = minutes === '00' ? '' : `:${minutes}`;
        
        if (hourNumber >= 13) {
          const convertedHour = hourNumber - 12;
          return `${convertedHour}${timeDisplay}PM`;
        } else if (hourNumber === 12) {
          return `12${timeDisplay}PM`;
        } else if (hourNumber === 0) {
          return `12${timeDisplay}AM`;
        } else {
          return `${hourNumber}${timeDisplay}AM`;
        }
      },
      capitalize(str) {
        if (!str) return ''
        return str.charAt(0).toUpperCase() + str.slice(1)
      },
    }
  }
  </script>
  
  